import Vue from 'vue'

let baseURL
//切换环境
if (process.env.NODE_ENV == 'development') {
    // baseURL = 'http://127.0.0.1:8082';
    // baseURL = 'http://gxcj-dev.scjfu.com';
       baseURL = 'https://api.fjtwfw.com';
}
else if (process.env.NODE_ENV == 'debug') {
    baseURL = 'http://gxcj-dev.scjfu.com';
}
else if (process.env.NODE_ENV == 'production') {
    baseURL = 'https://api.fjtwfw.com';
}
// console.log(process.env.NODE_ENV); // 打印结果为 'development' 
Vue.prototype.$baseURL = baseURL


export default {
    baseURL
};
